export const labelsPj = {
  cpfCnpj: 'CNPJ do Investidor',
  razaosocial: 'Razão Social',
  dataNascimento: 'Data de Constituição',
  nacionalidade: 'Local da Sede',
  profissao: 'Atividade Principal',
  investidorPoliticamenteExposto: 'Investidor Politicamente Exposto',
  tipoInvestidor: 'Tipo de Investidor',
  rendaMensalDeclarada: 'Faturamento Mensal',
  patrimonioDeclarado: 'Capital Social',
  vinculadoCustodiante: 'Vinculado ao Custodiante',
  endereco: 'Endereço Comercial',
  cep: 'CEP',
  logradouro: 'Logradouro',
  complemento: 'Complemento',
  bairro: 'Bairro',
  cidade: 'Cidade',
  uf: 'Unidade de Federação',
  numero: 'Número',
  telefone: 'Telefone',
  email: 'E-mail',
  cnpjCustodiante: 'CNPJ do Custodiante',
  razaoSocialCustodiante: 'Razão Social do Custodiante',
  cnaePrincipal: 'CNAE Principal',
  banco: 'Banco',
  ispbBanco: 'Banco ISPB',
  agencia: 'Agência',
  agenciaDigito: 'Dígito da Agência',
  conta: 'Conta',
  contaDigito: 'Dígito da Conta',
};

export const labelsPf = {
  cpfCnpj: 'CPF do Investidor',
  razaosocial: 'Nome do Investidor',
  dataNascimento: 'Data de Nascimento',
  nacionalidade: 'Nacionalidade',
  profissao: 'Profissão',
  investidorPoliticamenteExposto: 'Investidor Politicamente Exposto',
  tipoInvestidor: 'Tipo de Investidor',
  rendaMensalDeclarada: 'Renda Mensal Declarada',
  patrimonioDeclarado: 'Patrimônio Declarado',
  vinculadoCustodiante: 'Vinculado ao Custodiante',
  endereco: 'Endereço',
  cep: 'CEP',
  logradouro: 'Logradouro',
  complemento: 'Complemento',
  bairro: 'Bairro',
  cidade: 'Cidade',
  uf: 'Unidade de Federação',
  numero: 'Número',
  telefone: 'Telefone',
  email: 'E-mail',
  cnpjCustodiante: 'CNPJ do Custodiante',
  razaoSocialCustodiante: 'Razão Social do Custodiante',
  cnaePrincipal: 'CNAE Principal',
  banco: 'Banco',
  ispbBanco: 'Banco ISPB',
  agencia: 'Agência',
  agenciaDigito: 'Dígito da Agência',
  conta: 'Conta',
  contaDigito: 'Dígito da Conta',
};
